import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { getToken } from '../utils/storage';
import Index from '../views/index.vue';

const routes: Array<RouteRecordRaw> = [
    {
        name: 'notFound',
        path: '/:path(.*)+',
        redirect: {
            name: 'index',
        },
    },
    {
        name: 'index',
        path: '/',
        component: Index,
    },
    {
        path: '/login',
        component: () => import('../views/login.vue'),
    },
    {
        name: 'Chat',
        path: '/chat',
        component: Index,
    },
    {
        name: 'Admin',
        path: '/admin',
        component: () => import('../views/admin.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// TODO: 检测是否登录过，以及token是否过期，未登录或者过期则重定向到登录页
// eslint-disable-next-line
router.beforeEach((to, from, next) => {
    if (to.path === '/' && to.query.code) {
        next();
    } else if (to.path === '/login') {
        next();
    } else {
        const token = getToken();
        const loginTime = +(localStorage.getItem('loginTime') || '');
        const diffLoginTime = Date.now() - loginTime;
        if (token === '' || diffLoginTime > 586800000) {
            if (from.path === '/' && to.path === '/join-group' && to.query.q) {
                const redirect = {
                    path: '/join-group',
                    query: JSON.parse(window.atob(to.query.q as string)),
                };
                localStorage.setItem('redirectAfterLogin', JSON.stringify(redirect));
            }
            next({
                path: '/login',
            });
        } else {
            next();
        }
    }
});

export default router;
